import React from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

interface VoteDisplayProps {
    votes: number;
    onVote: (vote: number) => void;
    currentVote: number;
}

const VoteDisplay: React.FC<VoteDisplayProps> = ({ votes, onVote, currentVote }) => {
    function handleLike() {
        onVote(1);
    }

    function handleDislike() {
        onVote(-1);
    }

    return (
        <ButtonGroup variant="outlined" sx={{ p: 0 }}>
            <Button
                onClick={handleLike}
                startIcon={<ArrowUpwardIcon />}
                color={currentVote === 1 ? "success" : "primary"}
            >
                {votes}
            </Button>
            <Button
                onClick={handleDislike}
                endIcon={<ArrowDownwardIcon />}
                color={currentVote === -1 ? "error" : "primary"}
            ></Button>
        </ButtonGroup>
    );
};

export default VoteDisplay;
